/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'
import LayoutView from '@/layout/layout'

export default {
	path: '/initialized',
	component: Layout,
	redirect: 'noRedirect',
	name: '商户',
	meta: {
		title: '商户',
		icon: 'component'
	},
	children: [
		{
			path: 'initial',
			component: () => import(/* webpackChunkName: "initial" */ '@/leniuview/Business/initialized'),
			name: '商户初始化',
			meta: {
				title: '商户注册',
				redirect: 'audit'
			}
		},
		{
			path: 'initializedList',
			component: () => import(/* webpackChunkName: "initializedList" */ '@/leniuview/Business/initializedList'),
			name: '商户初始化',
			meta: {
				title: '商户审核',
				redirect: 'audit',
				noCache: true
			}
		},
		// {
		// 	path: 'menurole',
		// 	component: () =>
		// 		import(/* webpackChunkName: "menurole" */ '@/leniuview/basesetting/role/menurole'),
		// 	name: '菜单管理',
		// 	meta: { title: '菜单管理', noCache: true, redirect: 'menurole' }
		// },
		{
			path: 'menu-manager',
			component: () => import(/* webpackChunkName: "menu-manager" */ '@/leniuview/Business/menu-manager'),
			name: '菜单管理',
			meta: { title: '菜单管理', noCache: true }
		},
		{
			path: 'openApi',
			component: () => import(/* webpackChunkName: "openApi" */ '@/leniuview/open/openApi'),
			name: '商户初始化',
			meta: {
				title: '开放接口',
				redirect: 'audit',
				noCache: true
			}
		},
		{
			path: 'openAuthorize',
			component: () => import(/* webpackChunkName: "openAuthorize" */ '@/leniuview/open/openApp'),
			name: '商户初始化',
			meta: {
				title: '接口授权',
				redirect: 'audit',
				noCache: true
			}
		},
		{
			path: 'miniProgram',
			component: () => import(/* webpackChunkName: "miniProgram" */ '@/leniuview/alipayManage/miniProgram'),
			name: '商户初始化',
			meta: {
				title: '支付宝小程序管理',
				redirect: 'audit',
				noCache: true
			}
		},
		{
			path: 'adapter',
			component: LayoutView,
			name: '第三方对接',
			meta: {
				title: '第三方对接',
				noCache: true
			},
			redirect: 'datasync',
			children: [
				{
					path: 'thirdapi',
					component: () => import(/* webpackChunkName: "thirdapi" */ '@/leniuview/basesetting/adapter/thirdApi'),
					name: '公共接口',
					meta: {
						title: '公共接口',
						noCache: true
					}
				},
				{
					path: 'glue',
					component: () => import(/* webpackChunkName: "glue" */ '@/leniuview/basesetting/adapter/glue'),
					name: '动态代码',
					meta: {
						title: '动态代码',
						noCache: true
					}
				},
				{
					path: 'datasync',
					component: () => import(/* webpackChunkName: "datasync" */ '@/leniuview/basesetting/adapter/dataSync'),
					name: '数据拉取',
					meta: { title: '数据拉取', noCache: true }
				},
				{
					path: 'datapush',
					component: () => import(/* webpackChunkName: "datapush" */ '@/leniuview/basesetting/adapter/dataPush'),
					name: '数据拉取',
					meta: { title: '数据推送', noCache: true }
				},
				{
					path: 'customBiz',
					component: () => import(/* webpackChunkName: "customBiz" */ '@/leniuview/basesetting/adapter/customBiz'),
					name: '自定义业务',
					meta: {
						title: '自定义业务',
						noCache: true
					}
				},
				{
					path: 'manage',
					component: () => import(/* webpackChunkName: "manage" */ '@/leniuview/basesetting/adapter/manage'),
					name: '对接配置管理',
					meta: {
						title: '对接配置管理',
						noCache: true
					}
				}
			]
		}
		// {
		//   path: "checkaccount",
		//   component: () =>
		//     import ( /* webpackChunkName: "checkaccount" */ "@/leniuview/reportCenter/checkaccount"),
		//   name: "对账",
		//   meta: {
		//     title: "对账",
		//     redirect: "audit"
		//   }
		// },
	]
}
